import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
  } from '@angular/core';
  import { MarketingBannerData, TitleInfo } from '../../../common/interfaces';
import { Asset } from '../../../common/generated-types';
import { TextAlignment } from '../../../common/enums';

  @Component({
    selector: 'vsf-text-only-banner',
    templateUrl: './text-only-banner.component.html',
    styleUrls: ['./text-only-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
  })
  export class TextOnlyBannerComponent implements OnInit {
    @Input() banner!: MarketingBannerData;
    @Input() isMobile = false;
    @Input() linePadding: string;
    @Input() titleInfo: TitleInfo | null = null;
    @Input() pageFullWidth: boolean = false;
    @Input() sectionMaxHeight: string = '';

    backgroundColor = '#fff';
    textColor = '#000';
    textAlign: TextAlignment = TextAlignment.Left;
    descWidth = '100%';
    descIndent = '0px';
    titleIndent = '0px';
    bgMedia?: Asset | null;
    shadowOpacity = 0;
    titleFontSize: number = 30;
    textFontSize: number = 16;
    mobileTitleFontSize: number = 20;
    mobileTextFontSize: number = 14;
    textBarStyle: string = 'none';

    ngOnInit(): void {
      if (this.banner) {
        this.backgroundColor    = this.banner.backgroundColor   ?? '#fff';
        this.textColor  = this.banner.textColor         ?? '#000';
        this.textAlign  = this.banner.textAlignment as any ?? 'left';
        this.titleFontSize = this.banner.titleFontSize ?? this.titleFontSize;
        this.textFontSize = this.banner.textFontSize ?? this.textFontSize;
        this.textBarStyle = this.banner.textBarStyle ?? 'none';
        this.mobileTitleFontSize = this.banner.titleFontSize ? Math.round(this.banner.titleFontSize * 2 / 3) : this.mobileTitleFontSize;
        this.mobileTextFontSize = this.banner.textFontSize ? (this.banner.textFontSize - 2) : this.mobileTextFontSize;
        this.descWidth  = (this.banner.textWidth ?? 1) * 100 + '%';
        this.titleIndent = (this.banner.titleIndentation ?? 0) + 'px';
        this.descIndent = (this.banner.textIndentation ?? 0) + 'px';
        this.bgMedia = this.isMobile ? this.banner.backgroundMobileMedia : this.banner.backgroundMedia;
        this.shadowOpacity = ( 1.0 - this.banner?.shadowTransparencyValue) || this.shadowOpacity;
      }
    }
  }
